export const quizQuestions = [
  {
    id: "question6",
    videoId: "video6",
    topic: "Speed Restrictions",
    question: "Speed restrictions depends on these factors: ",
    options: [
      "Vehicle Weight and Maximum Speed Limit",
      "Vehicle Category and Road Classification",
      "Carrying Capacity and Road Type",
    ],
    correctAnswer: "Vehicle Category and Road Classification",
    descriptionTitle: "Speed Restrictions",
    description1:
      "Every type of vehicle that is driven in the Philippines will have a certain speed limit or restriction that will vary depending on several factors. These factors include, but are not limited to Vehicle category, Road classification such as if it is National Road, Provincial Road, and Municipal and City Road. These vehicle speed limitations are still subject to change as the speed limits that are posted on the traffic signage will prevail and should be followed at all times.",
  },
];
